import faqs from './components/faqs';
import addUrlParams from './components/add-url-params';
import collapsedContent from './components/collapsable-content';
import stickyCTA from './components/sticky-cta-best';
import productFieldsetAccordion from './components/product-fieldset-accordion';
import authorMetaListenBest from './components/author-meta-listen-best'

faqs();
addUrlParams();
collapsedContent();
stickyCTA();
productFieldsetAccordion();
authorMetaListenBest();